<p-progressBar
  [value]="value"
  [showValue]="false"
  [mode]="mode"
  [unit]="unit"
  [styleClass]="extendedStyleClass"
  class="m-progress-bar"></p-progressBar>
